import get from 'lodash/get';
import type { ApolloError } from 'apollo-client';
import {
	NO_STARTED_SPRINT_AVAILABLE_ERROR_KEY,
	NO_SUCH_SPRINT_FOUND_ERROR_KEY,
} from '../../constants';
import type { SprintReportsFilters, State } from '../../types';
import { getSprintFilterRank } from '../filters';

type Attributes = {
	[key: string]: string | number | null;
};

export const getTrackEventContextAttributes = (
	state: State,
	filters: SprintReportsFilters | null,
): Attributes => ({
	estimationStatistic: state.estimation,
	sprintFilterRank: getSprintFilterRank(
		filters && filters.sprints,
		state.sprint && state.sprint.id,
	),
	totalSprints: filters && filters.sprints.length,
});

export const isKnownSprintError = (error: ApolloError | null): boolean => {
	if (!error) {
		return false;
	}

	if (!error.graphQLErrors || !error.graphQLErrors.length) {
		return false;
	}

	const errorKey = get(error.graphQLErrors[0], ['extensions', 'errorType'], null);

	return (
		errorKey === NO_STARTED_SPRINT_AVAILABLE_ERROR_KEY ||
		errorKey === NO_SUCH_SPRINT_FOUND_ERROR_KEY
	);
};
